module.exports = __webpack_public_path__ + "img/logo-red-black.4d055442.png";